// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.110.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.110.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&family=Poppins:wght@300;400;500;600;700;800;900&family=JetBrains+Mono:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: JetBrains Mono, Fira Code, Monaco, Consolas, monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.\\!container{
  width: 100% !important;
}
.container{
  width: 100%;
}
@media (min-width: 640px){
  .\\!container{
    max-width: 640px !important;
  }
  .container{
    max-width: 640px;
  }
}
@media (min-width: 768px){
  .\\!container{
    max-width: 768px !important;
  }
  .container{
    max-width: 768px;
  }
}
@media (min-width: 1024px){
  .\\!container{
    max-width: 1024px !important;
  }
  .container{
    max-width: 1024px;
  }
}
@media (min-width: 1280px){
  .\\!container{
    max-width: 1280px !important;
  }
  .container{
    max-width: 1280px;
  }
}
@media (min-width: 1536px){
  .\\!container{
    max-width: 1536px !important;
  }
  .container{
    max-width: 1536px;
  }
}
.sr-only{
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border-width: 0 !important;
}
.pointer-events-none{
  pointer-events: none !important;
}
.visible{
  visibility: visible !important;
}
.fixed{
  position: fixed !important;
}
.absolute{
  position: absolute !important;
}
.relative{
  position: relative !important;
}
.inset-0{
  inset: 0px !important;
}
.inset-y-0{
  top: 0px !important;
  bottom: 0px !important;
}
.bottom-20{
  bottom: 5rem !important;
}
.bottom-5{
  bottom: 1.25rem !important;
}
.left-0{
  left: 0px !important;
}
.right-0{
  right: 0px !important;
}
.right-2{
  right: 0.5rem !important;
}
.right-3{
  right: 0.75rem !important;
}
.right-5{
  right: 1.25rem !important;
}
.top-0{
  top: 0px !important;
}
.top-2{
  top: 0.5rem !important;
}
.top-\\[calc\\(100\\%\\+6px\\)\\]{
  top: calc(100% + 6px) !important;
}
.z-10{
  z-index: 10 !important;
}
.z-40{
  z-index: 40 !important;
}
.z-50{
  z-index: 50 !important;
}
.z-\\[1000\\]{
  z-index: 1000 !important;
}
.z-\\[880\\]{
  z-index: 880 !important;
}
.z-\\[900\\]{
  z-index: 900 !important;
}
.z-\\[910\\]{
  z-index: 910 !important;
}
.col-span-3{
  grid-column: span 3 / span 3 !important;
}
.m-0{
  margin: 0px !important;
}
.mx-auto{
  margin-left: auto !important;
  margin-right: auto !important;
}
.my-2{
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}
.my-4{
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}
.-mb-\\[2px\\]{
  margin-bottom: -2px !important;
}
.mb-1{
  margin-bottom: 0.25rem !important;
}
.mb-1\\.5{
  margin-bottom: 0.375rem !important;
}
.mb-2{
  margin-bottom: 0.5rem !important;
}
.mb-3{
  margin-bottom: 0.75rem !important;
}
.mb-4{
  margin-bottom: 1rem !important;
}
.mb-5{
  margin-bottom: 1.25rem !important;
}
.mb-6{
  margin-bottom: 1.5rem !important;
}
.mb-8{
  margin-bottom: 2rem !important;
}
.ml-2{
  margin-left: 0.5rem !important;
}
.ml-3{
  margin-left: 0.75rem !important;
}
.mr-2{
  margin-right: 0.5rem !important;
}
.mt-0\\.5{
  margin-top: 0.125rem !important;
}
.mt-1{
  margin-top: 0.25rem !important;
}
.mt-2{
  margin-top: 0.5rem !important;
}
.mt-3{
  margin-top: 0.75rem !important;
}
.mt-4{
  margin-top: 1rem !important;
}
.mt-5{
  margin-top: 1.25rem !important;
}
.mt-6{
  margin-top: 1.5rem !important;
}
.mt-8{
  margin-top: 2rem !important;
}
.box-border{
  box-sizing: border-box !important;
}
.block{
  display: block !important;
}
.inline-block{
  display: inline-block !important;
}
.flex{
  display: flex !important;
}
.inline-flex{
  display: inline-flex !important;
}
.table{
  display: table !important;
}
.grid{
  display: grid !important;
}
.hidden{
  display: none !important;
}
.h-1\\.5{
  height: 0.375rem !important;
}
.h-10{
  height: 2.5rem !important;
}
.h-11{
  height: 2.75rem !important;
}
.h-12{
  height: 3rem !important;
}
.h-14{
  height: 3.5rem !important;
}
.h-2{
  height: 0.5rem !important;
}
.h-2\\.5{
  height: 0.625rem !important;
}
.h-3\\.5{
  height: 0.875rem !important;
}
.h-4{
  height: 1rem !important;
}
.h-5{
  height: 1.25rem !important;
}
.h-6{
  height: 1.5rem !important;
}
.h-7{
  height: 1.75rem !important;
}
.h-8{
  height: 2rem !important;
}
.h-9{
  height: 2.25rem !important;
}
.h-full{
  height: 100% !important;
}
.h-px{
  height: 1px !important;
}
.h-screen{
  height: 100vh !important;
}
.max-h-48{
  max-height: 12rem !important;
}
.max-h-60{
  max-height: 15rem !important;
}
.max-h-64{
  max-height: 16rem !important;
}
.max-h-80{
  max-height: 20rem !important;
}
.max-h-\\[220px\\]{
  max-height: 220px !important;
}
.max-h-\\[300px\\]{
  max-height: 300px !important;
}
.max-h-\\[500px\\]{
  max-height: 500px !important;
}
.min-h-\\[42px\\]{
  min-height: 42px !important;
}
.min-h-\\[88px\\]{
  min-height: 88px !important;
}
.min-h-\\[98px\\]{
  min-height: 98px !important;
}
.min-h-\\[calc\\(100vh-170px\\)\\]{
  min-height: calc(100vh - 170px) !important;
}
.min-h-screen{
  min-height: 100vh !important;
}
.w-1\\.5{
  width: 0.375rem !important;
}
.w-10{
  width: 2.5rem !important;
}
.w-11{
  width: 2.75rem !important;
}
.w-11\\/12{
  width: 91.666667% !important;
}
.w-12{
  width: 3rem !important;
}
.w-14{
  width: 3.5rem !important;
}
.w-16{
  width: 4rem !important;
}
.w-2{
  width: 0.5rem !important;
}
.w-2\\.5{
  width: 0.625rem !important;
}
.w-20{
  width: 5rem !important;
}
.w-24{
  width: 6rem !important;
}
.w-3\\.5{
  width: 0.875rem !important;
}
.w-4{
  width: 1rem !important;
}
.w-5{
  width: 1.25rem !important;
}
.w-6{
  width: 1.5rem !important;
}
.w-7{
  width: 1.75rem !important;
}
.w-72{
  width: 18rem !important;
}
.w-8{
  width: 2rem !important;
}
.w-9{
  width: 2.25rem !important;
}
.w-\\[460px\\]{
  width: 460px !important;
}
.w-\\[500px\\]{
  width: 500px !important;
}
.w-fit{
  width: -moz-fit-content !important;
  width: fit-content !important;
}
.w-full{
  width: 100% !important;
}
.min-w-0{
  min-width: 0px !important;
}
.min-w-\\[120px\\]{
  min-width: 120px !important;
}
.min-w-\\[122px\\]{
  min-width: 122px !important;
}
.min-w-\\[140px\\]{
  min-width: 140px !important;
}
.min-w-\\[160px\\]{
  min-width: 160px !important;
}
.min-w-\\[210px\\]{
  min-width: 210px !important;
}
.min-w-\\[220px\\]{
  min-width: 220px !important;
}
.min-w-\\[880px\\]{
  min-width: 880px !important;
}
.min-w-full{
  min-width: 100% !important;
}
.max-w-\\[1600px\\]{
  max-width: 1600px !important;
}
.max-w-\\[85vw\\]{
  max-width: 85vw !important;
}
.max-w-\\[90vw\\]{
  max-width: 90vw !important;
}
.max-w-\\[92vw\\]{
  max-width: 92vw !important;
}
.max-w-full{
  max-width: 100% !important;
}
.max-w-sm{
  max-width: 24rem !important;
}
.flex-1{
  flex: 1 1 0% !important;
}
.flex-shrink-0{
  flex-shrink: 0 !important;
}
.shrink-0{
  flex-shrink: 0 !important;
}
.border-collapse{
  border-collapse: collapse !important;
}
.translate-x-0{
  --tw-translate-x: 0px !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.translate-x-5{
  --tw-translate-x: 1.25rem !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.rotate-180{
  --tw-rotate: 180deg !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
@keyframes fadeIn{
  0%{
    opacity: 0;
  }
  100%{
    opacity: 1;
  }
}
.animate-\\[fadeIn_0\\.2s\\]{
  animation: fadeIn 0.2s !important;
}
.animate-\\[slideDown_0\\.3s_ease-out\\]{
  animation: slideDown 0.3s ease-out !important;
}
.animate-\\[slideIn_0\\.3s\\]{
  animation: slideIn 0.3s !important;
}
@keyframes pulse{
  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite !important;
}
@keyframes spin{
  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite !important;
}
.cursor-pointer{
  cursor: pointer !important;
}
.select-none{
  -webkit-user-select: none !important;
     -moz-user-select: none !important;
          user-select: none !important;
}
.resize{
  resize: both !important;
}
.list-disc{
  list-style-type: disc !important;
}
.appearance-none{
  -webkit-appearance: none !important;
     -moz-appearance: none !important;
          appearance: none !important;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
}
.grid-cols-\\[auto_auto_auto\\]{
  grid-template-columns: auto auto auto !important;
}
.flex-row{
  flex-direction: row !important;
}
.flex-col{
  flex-direction: column !important;
}
.flex-col-reverse{
  flex-direction: column-reverse !important;
}
.flex-wrap{
  flex-wrap: wrap !important;
}
.items-start{
  align-items: flex-start !important;
}
.items-end{
  align-items: flex-end !important;
}
.items-center{
  align-items: center !important;
}
.justify-start{
  justify-content: flex-start !important;
}
.justify-end{
  justify-content: flex-end !important;
}
.justify-center{
  justify-content: center !important;
}
.justify-between{
  justify-content: space-between !important;
}
.gap-1{
  gap: 0.25rem !important;
}
.gap-1\\.5{
  gap: 0.375rem !important;
}
.gap-2{
  gap: 0.5rem !important;
}
.gap-3{
  gap: 0.75rem !important;
}
.gap-4{
  gap: 1rem !important;
}
.gap-5{
  gap: 1.25rem !important;
}
.gap-6{
  gap: 1.5rem !important;
}
.gap-x-8{
  -moz-column-gap: 2rem !important;
       column-gap: 2rem !important;
}
.gap-y-5{
  row-gap: 1.25rem !important;
}
.space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0 !important;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse)) !important;
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse))) !important;
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0 !important;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse))) !important;
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse)) !important;
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0 !important;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse))) !important;
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse)) !important;
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0 !important;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse))) !important;
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse)) !important;
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0 !important;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse))) !important;
  margin-bottom: calc(1rem * var(--tw-space-y-reverse)) !important;
}
.space-y-5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0 !important;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse))) !important;
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse)) !important;
}
.space-y-8 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0 !important;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse))) !important;
  margin-bottom: calc(2rem * var(--tw-space-y-reverse)) !important;
}
.self-start{
  align-self: flex-start !important;
}
.self-center{
  align-self: center !important;
}
.overflow-auto{
  overflow: auto !important;
}
.overflow-hidden{
  overflow: hidden !important;
}
.overflow-x-auto{
  overflow-x: auto !important;
}
.overflow-y-auto{
  overflow-y: auto !important;
}
.text-ellipsis{
  text-overflow: ellipsis !important;
}
.whitespace-nowrap{
  white-space: nowrap !important;
}
.whitespace-pre-wrap{
  white-space: pre-wrap !important;
}
.break-words{
  overflow-wrap: break-word !important;
}
.break-all{
  word-break: break-all !important;
}
.rounded{
  border-radius: 0.25rem !important;
}
.rounded-2xl{
  border-radius: 1rem !important;
}
.rounded-full{
  border-radius: 9999px !important;
}
.rounded-lg{
  border-radius: 0.5rem !important;
}
.rounded-md{
  border-radius: 0.375rem !important;
}
.rounded-xl{
  border-radius: 0.75rem !important;
}
.rounded-t-lg{
  border-top-left-radius: 0.5rem !important;
  border-top-right-radius: 0.5rem !important;
}
.border{
  border-width: 1px !important;
}
.border-0{
  border-width: 0px !important;
}
.border-2{
  border-width: 2px !important;
}
.border-4{
  border-width: 4px !important;
}
.border-\\[3px\\]{
  border-width: 3px !important;
}
.border-b{
  border-bottom-width: 1px !important;
}
.border-b-2{
  border-bottom-width: 2px !important;
}
.border-b-\\[3px\\]{
  border-bottom-width: 3px !important;
}
.border-l-4{
  border-left-width: 4px !important;
}
.border-l-\\[3px\\]{
  border-left-width: 3px !important;
}
.border-r{
  border-right-width: 1px !important;
}
.border-t{
  border-top-width: 1px !important;
}
.border-solid{
  border-style: solid !important;
}
.border-none{
  border-style: none !important;
}
.border-\\[rgba\\(255\\2c 153\\2c 0\\2c 0\\.3\\)\\]{
  border-color: rgba(255,153,0,0.3) !important;
}
.border-\\[rgba\\(94\\2c 234\\2c 212\\2c 0\\.3\\)\\]{
  border-color: rgba(94,234,212,0.3) !important;
}
.border-amber-300\\/50{
  border-color: rgb(252 211 77 / 0.5) !important;
}
.border-amber-400\\/30{
  border-color: rgb(251 191 36 / 0.3) !important;
}
.border-amber-500{
  --tw-border-opacity: 1 !important;
  border-color: rgb(245 158 11 / var(--tw-border-opacity, 1)) !important;
}
.border-amber-500\\/40{
  border-color: rgb(245 158 11 / 0.4) !important;
}
.border-amber-500\\/50{
  border-color: rgb(245 158 11 / 0.5) !important;
}
.border-amber-500\\/60{
  border-color: rgb(245 158 11 / 0.6) !important;
}
.border-blue-500\\/30{
  border-color: rgb(59 130 246 / 0.3) !important;
}
.border-blue-500\\/60{
  border-color: rgb(59 130 246 / 0.6) !important;
}
.border-gray-200{
  --tw-border-opacity: 1 !important;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1)) !important;
}
.border-green-200{
  --tw-border-opacity: 1 !important;
  border-color: rgb(187 247 208 / var(--tw-border-opacity, 1)) !important;
}
.border-green-400\\/30{
  border-color: rgb(74 222 128 / 0.3) !important;
}
.border-green-400\\/50{
  border-color: rgb(74 222 128 / 0.5) !important;
}
.border-green-500{
  --tw-border-opacity: 1 !important;
  border-color: rgb(34 197 94 / var(--tw-border-opacity, 1)) !important;
}
.border-green-500\\/30{
  border-color: rgb(34 197 94 / 0.3) !important;
}
.border-green-500\\/40{
  border-color: rgb(34 197 94 / 0.4) !important;
}
.border-green-500\\/60{
  border-color: rgb(34 197 94 / 0.6) !important;
}
.border-red-200{
  --tw-border-opacity: 1 !important;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1)) !important;
}
.border-red-400\\/30{
  border-color: rgb(248 113 113 / 0.3) !important;
}
.border-red-400\\/40{
  border-color: rgb(248 113 113 / 0.4) !important;
}
.border-red-400\\/50{
  border-color: rgb(248 113 113 / 0.5) !important;
}
.border-red-500{
  --tw-border-opacity: 1 !important;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1)) !important;
}
.border-red-500\\/30{
  border-color: rgb(239 68 68 / 0.3) !important;
}
.border-red-500\\/40{
  border-color: rgb(239 68 68 / 0.4) !important;
}
.border-red-500\\/50{
  border-color: rgb(239 68 68 / 0.5) !important;
}
.border-red-500\\/60{
  border-color: rgb(239 68 68 / 0.6) !important;
}
.border-red-700{
  --tw-border-opacity: 1 !important;
  border-color: rgb(185 28 28 / var(--tw-border-opacity, 1)) !important;
}
.border-secondary-400{
  --tw-border-opacity: 1 !important;
  border-color: rgb(148 163 184 / var(--tw-border-opacity, 1)) !important;
}
.border-secondary-600{
  --tw-border-opacity: 1 !important;
  border-color: rgb(71 85 105 / var(--tw-border-opacity, 1)) !important;
}
.border-secondary-700{
  --tw-border-opacity: 1 !important;
  border-color: rgb(51 65 85 / var(--tw-border-opacity, 1)) !important;
}
.border-secondary-800{
  --tw-border-opacity: 1 !important;
  border-color: rgb(30 41 59 / var(--tw-border-opacity, 1)) !important;
}
.border-slate-300\\/40{
  border-color: rgb(203 213 225 / 0.4) !important;
}
.border-transparent{
  border-color: transparent !important;
}
.border-white{
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1)) !important;
}
.border-white\\/10{
  border-color: rgb(255 255 255 / 0.1) !important;
}
.border-white\\/15{
  border-color: rgb(255 255 255 / 0.15) !important;
}
.border-white\\/20{
  border-color: rgb(255 255 255 / 0.2) !important;
}
.border-white\\/30{
  border-color: rgb(255 255 255 / 0.3) !important;
}
.border-white\\/5{
  border-color: rgb(255 255 255 / 0.05) !important;
}
.border-yellow-300{
  --tw-border-opacity: 1 !important;
  border-color: rgb(253 224 71 / var(--tw-border-opacity, 1)) !important;
}
.border-l-\\[\\#ff9900\\]{
  --tw-border-opacity: 1 !important;
  border-left-color: rgb(255 153 0 / var(--tw-border-opacity, 1)) !important;
}
.border-l-green-500{
  --tw-border-opacity: 1 !important;
  border-left-color: rgb(34 197 94 / var(--tw-border-opacity, 1)) !important;
}
.border-l-red-500{
  --tw-border-opacity: 1 !important;
  border-left-color: rgb(239 68 68 / var(--tw-border-opacity, 1)) !important;
}
.border-l-teal-300{
  --tw-border-opacity: 1 !important;
  border-left-color: rgb(94 234 212 / var(--tw-border-opacity, 1)) !important;
}
.border-t-white{
  --tw-border-opacity: 1 !important;
  border-top-color: rgb(255 255 255 / var(--tw-border-opacity, 1)) !important;
}
.bg-\\[\\#1b1e2e\\]{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(27 30 46 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#1b1e2e\\]\\/70{
  background-color: rgb(27 30 46 / 0.7) !important;
}
.bg-\\[\\#1b1e2f\\]{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(27 30 47 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#1e2233\\]{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(30 34 51 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#24283a\\]{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(36 40 58 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#24283a\\]\\/70{
  background-color: rgb(36 40 58 / 0.7) !important;
}
.bg-\\[\\#24283a\\]\\/80{
  background-color: rgb(36 40 58 / 0.8) !important;
}
.bg-\\[\\#30344a\\]{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(48 52 74 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#34344A\\]{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(52 52 74 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#34344a\\]{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(52 52 74 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[rgba\\(255\\2c 153\\2c 0\\2c 0\\.2\\)\\]{
  background-color: rgba(255,153,0,0.2) !important;
}
.bg-\\[rgba\\(94\\2c 234\\2c 212\\2c 0\\.15\\)\\]{
  background-color: rgba(94,234,212,0.15) !important;
}
.bg-amber-500{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1)) !important;
}
.bg-amber-500\\/10{
  background-color: rgb(245 158 11 / 0.1) !important;
}
.bg-amber-500\\/20{
  background-color: rgb(245 158 11 / 0.2) !important;
}
.bg-amber-500\\/25{
  background-color: rgb(245 158 11 / 0.25) !important;
}
.bg-black{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1)) !important;
}
.bg-black\\/20{
  background-color: rgb(0 0 0 / 0.2) !important;
}
.bg-black\\/25{
  background-color: rgb(0 0 0 / 0.25) !important;
}
.bg-black\\/30{
  background-color: rgb(0 0 0 / 0.3) !important;
}
.bg-blue-500\\/10{
  background-color: rgb(59 130 246 / 0.1) !important;
}
.bg-blue-500\\/25{
  background-color: rgb(59 130 246 / 0.25) !important;
}
.bg-blue-600{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1)) !important;
}
.bg-emerald-500\\/20{
  background-color: rgb(16 185 129 / 0.2) !important;
}
.bg-gray-200{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1)) !important;
}
.bg-gray-50{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1)) !important;
}
.bg-green-100{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1)) !important;
}
.bg-green-400{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity, 1)) !important;
}
.bg-green-50{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1)) !important;
}
.bg-green-500{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1)) !important;
}
.bg-green-500\\/10{
  background-color: rgb(34 197 94 / 0.1) !important;
}
.bg-green-500\\/20{
  background-color: rgb(34 197 94 / 0.2) !important;
}
.bg-green-500\\/25{
  background-color: rgb(34 197 94 / 0.25) !important;
}
.bg-indigo-50{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1)) !important;
}
.bg-indigo-500\\/20{
  background-color: rgb(99 102 241 / 0.2) !important;
}
.bg-primary-100{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1)) !important;
}
.bg-primary-500{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1)) !important;
}
.bg-primary-600{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1)) !important;
}
.bg-primary-800{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(30 64 175 / var(--tw-bg-opacity, 1)) !important;
}
.bg-red-100{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1)) !important;
}
.bg-red-50{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1)) !important;
}
.bg-red-500{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1)) !important;
}
.bg-red-500\\/10{
  background-color: rgb(239 68 68 / 0.1) !important;
}
.bg-red-500\\/15{
  background-color: rgb(239 68 68 / 0.15) !important;
}
.bg-red-500\\/20{
  background-color: rgb(239 68 68 / 0.2) !important;
}
.bg-red-500\\/25{
  background-color: rgb(239 68 68 / 0.25) !important;
}
.bg-red-600{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1)) !important;
}
.bg-red-900{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(127 29 29 / var(--tw-bg-opacity, 1)) !important;
}
.bg-secondary-600{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(71 85 105 / var(--tw-bg-opacity, 1)) !important;
}
.bg-secondary-700{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity, 1)) !important;
}
.bg-secondary-800{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1)) !important;
}
.bg-secondary-900{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1)) !important;
}
.bg-secondary-900\\/40{
  background-color: rgb(15 23 42 / 0.4) !important;
}
.bg-sky-500\\/20{
  background-color: rgb(14 165 233 / 0.2) !important;
}
.bg-slate-400\\/20{
  background-color: rgb(148 163 184 / 0.2) !important;
}
.bg-slate-50{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1)) !important;
}
.bg-transparent{
  background-color: transparent !important;
}
.bg-white{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
}
.bg-white\\/10{
  background-color: rgb(255 255 255 / 0.1) !important;
}
.bg-white\\/15{
  background-color: rgb(255 255 255 / 0.15) !important;
}
.bg-white\\/20{
  background-color: rgb(255 255 255 / 0.2) !important;
}
.bg-white\\/5{
  background-color: rgb(255 255 255 / 0.05) !important;
}
.bg-white\\/\\[0\\.06\\]{
  background-color: rgb(255 255 255 / 0.06) !important;
}
.bg-yellow-100{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity, 1)) !important;
}
.bg-yellow-50{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(254 252 232 / var(--tw-bg-opacity, 1)) !important;
}
.bg-zinc-100{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(244 244 245 / var(--tw-bg-opacity, 1)) !important;
}
.bg-opacity-40{
  --tw-bg-opacity: 0.4 !important;
}
.bg-opacity-50{
  --tw-bg-opacity: 0.5 !important;
}
.bg-\\[linear-gradient\\(135deg\\2c rgba\\(129\\2c 140\\2c 248\\2c 0\\.12\\)_0\\%\\2c rgba\\(255\\2c 255\\2c 255\\2c 0\\.025\\)_100\\%\\)\\]{
  background-image: linear-gradient(135deg,rgba(129,140,248,0.12) 0%,rgba(255,255,255,0.025) 100%) !important;
}
.bg-\\[linear-gradient\\(135deg\\2c rgba\\(239\\2c 68\\2c 68\\2c 0\\.16\\)_0\\%\\2c rgba\\(255\\2c 255\\2c 255\\2c 0\\.025\\)_100\\%\\)\\]{
  background-image: linear-gradient(135deg,rgba(239,68,68,0.16) 0%,rgba(255,255,255,0.025) 100%) !important;
}
.bg-\\[linear-gradient\\(135deg\\2c rgba\\(245\\2c 158\\2c 11\\2c 0\\.16\\)_0\\%\\2c rgba\\(255\\2c 255\\2c 255\\2c 0\\.025\\)_100\\%\\)\\]{
  background-image: linear-gradient(135deg,rgba(245,158,11,0.16) 0%,rgba(255,255,255,0.025) 100%) !important;
}
.bg-\\[linear-gradient\\(135deg\\2c rgba\\(255\\2c 255\\2c 255\\2c 0\\.045\\)_0\\%\\2c rgba\\(255\\2c 255\\2c 255\\2c 0\\.02\\)_100\\%\\)\\]{
  background-image: linear-gradient(135deg,rgba(255,255,255,0.045) 0%,rgba(255,255,255,0.02) 100%) !important;
}
.bg-\\[linear-gradient\\(135deg\\2c rgba\\(34\\2c 197\\2c 94\\2c 0\\.16\\)_0\\%\\2c rgba\\(255\\2c 255\\2c 255\\2c 0\\.025\\)_100\\%\\)\\]{
  background-image: linear-gradient(135deg,rgba(34,197,94,0.16) 0%,rgba(255,255,255,0.025) 100%) !important;
}
.bg-\\[linear-gradient\\(135deg\\2c rgba\\(59\\2c 130\\2c 246\\2c 0\\.16\\)_0\\%\\2c rgba\\(255\\2c 255\\2c 255\\2c 0\\.025\\)_100\\%\\)\\]{
  background-image: linear-gradient(135deg,rgba(59,130,246,0.16) 0%,rgba(255,255,255,0.025) 100%) !important;
}
.bg-\\[linear-gradient\\(90deg\\2c \\#22c55e\\2c \\#16a34a\\)\\]{
  background-image: linear-gradient(90deg,#22c55e,#16a34a) !important;
}
.to-\\[\\#1a6bc4\\]{
  --tw-gradient-to: #1a6bc4 var(--tw-gradient-to-position) !important;
}
.p-0{
  padding: 0px !important;
}
.p-1{
  padding: 0.25rem !important;
}
.p-2{
  padding: 0.5rem !important;
}
.p-3{
  padding: 0.75rem !important;
}
.p-4{
  padding: 1rem !important;
}
.p-5{
  padding: 1.25rem !important;
}
.p-6{
  padding: 1.5rem !important;
}
.px-0{
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.px-1{
  padding-left: 0.25rem !important;
  padding-right: 0.25rem !important;
}
.px-1\\.5{
  padding-left: 0.375rem !important;
  padding-right: 0.375rem !important;
}
.px-2{
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}
.px-3{
  padding-left: 0.75rem !important;
  padding-right: 0.75rem !important;
}
.px-4{
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}
.px-5{
  padding-left: 1.25rem !important;
  padding-right: 1.25rem !important;
}
.px-6{
  padding-left: 1.5rem !important;
  padding-right: 1.5rem !important;
}
.px-8{
  padding-left: 2rem !important;
  padding-right: 2rem !important;
}
.py-0\\.5{
  padding-top: 0.125rem !important;
  padding-bottom: 0.125rem !important;
}
.py-1{
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}
.py-1\\.5{
  padding-top: 0.375rem !important;
  padding-bottom: 0.375rem !important;
}
.py-12{
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}
.py-16{
  padding-top: 4rem !important;
  padding-bottom: 4rem !important;
}
.py-2{
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
.py-2\\.5{
  padding-top: 0.625rem !important;
  padding-bottom: 0.625rem !important;
}
.py-3{
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
}
.py-4{
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}
.py-5{
  padding-top: 1.25rem !important;
  padding-bottom: 1.25rem !important;
}
.py-6{
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}
.pb-2{
  padding-bottom: 0.5rem !important;
}
.pb-3{
  padding-bottom: 0.75rem !important;
}
.pb-4{
  padding-bottom: 1rem !important;
}
.pl-5{
  padding-left: 1.25rem !important;
}
.pr-10{
  padding-right: 2.5rem !important;
}
.pr-12{
  padding-right: 3rem !important;
}
.pr-4{
  padding-right: 1rem !important;
}
.pt-2{
  padding-top: 0.5rem !important;
}
.pt-3{
  padding-top: 0.75rem !important;
}
.pt-4{
  padding-top: 1rem !important;
}
.pt-5{
  padding-top: 1.25rem !important;
}
.pt-6{
  padding-top: 1.5rem !important;
}
.pt-8{
  padding-top: 2rem !important;
}
.text-left{
  text-align: left !important;
}
.text-center{
  text-align: center !important;
}
.text-right{
  text-align: right !important;
}
.align-top{
  vertical-align: top !important;
}
.font-\\[\\'Courier_New\\'\\2c monospace\\]{
  font-family: 'Courier New',monospace !important;
}
.font-display{
  font-family: Poppins, Inter, system-ui, sans-serif !important;
}
.font-mono{
  font-family: JetBrains Mono, Fira Code, Monaco, Consolas, monospace !important;
}
.font-sans{
  font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif !important;
}
.text-2xl{
  font-size: 1.5rem !important;
  line-height: 2rem !important;
}
.text-3xl{
  font-size: 1.875rem !important;
  line-height: 2.25rem !important;
}
.text-\\[0\\.65rem\\]{
  font-size: 0.65rem !important;
}
.text-\\[0\\.813rem\\]{
  font-size: 0.813rem !important;
}
.text-\\[0\\.938rem\\]{
  font-size: 0.938rem !important;
}
.text-\\[1\\.125rem\\]{
  font-size: 1.125rem !important;
}
.text-\\[1\\.5rem\\]{
  font-size: 1.5rem !important;
}
.text-\\[1\\.75rem\\]{
  font-size: 1.75rem !important;
}
.text-\\[11px\\]{
  font-size: 11px !important;
}
.text-\\[13px\\]{
  font-size: 13px !important;
}
.text-\\[15px\\]{
  font-size: 15px !important;
}
.text-base{
  font-size: 1rem !important;
  line-height: 1.5rem !important;
}
.text-lg{
  font-size: 1.125rem !important;
  line-height: 1.75rem !important;
}
.text-sm{
  font-size: 0.875rem !important;
  line-height: 1.25rem !important;
}
.text-xl{
  font-size: 1.25rem !important;
  line-height: 1.75rem !important;
}
.text-xs{
  font-size: 0.75rem !important;
  line-height: 1rem !important;
}
.font-bold{
  font-weight: 700 !important;
}
.font-extrabold{
  font-weight: 800 !important;
}
.font-medium{
  font-weight: 500 !important;
}
.font-normal{
  font-weight: 400 !important;
}
.font-semibold{
  font-weight: 600 !important;
}
.uppercase{
  text-transform: uppercase !important;
}
.leading-6{
  line-height: 1.5rem !important;
}
.leading-7{
  line-height: 1.75rem !important;
}
.leading-none{
  line-height: 1 !important;
}
.leading-relaxed{
  line-height: 1.625 !important;
}
.leading-tight{
  line-height: 1.25 !important;
}
.tracking-\\[0\\.01em\\]{
  letter-spacing: 0.01em !important;
}
.tracking-\\[0\\.15em\\]{
  letter-spacing: 0.15em !important;
}
.tracking-\\[0\\.2em\\]{
  letter-spacing: 0.2em !important;
}
.tracking-\\[0\\.3px\\]{
  letter-spacing: 0.3px !important;
}
.tracking-\\[0\\.5px\\]{
  letter-spacing: 0.5px !important;
}
.tracking-\\[1px\\]{
  letter-spacing: 1px !important;
}
.tracking-tight{
  letter-spacing: -0.025em !important;
}
.text-\\[\\#ffa500\\]{
  --tw-text-opacity: 1 !important;
  color: rgb(255 165 0 / var(--tw-text-opacity, 1)) !important;
}
.text-amber-100{
  --tw-text-opacity: 1 !important;
  color: rgb(254 243 199 / var(--tw-text-opacity, 1)) !important;
}
.text-amber-200{
  --tw-text-opacity: 1 !important;
  color: rgb(253 230 138 / var(--tw-text-opacity, 1)) !important;
}
.text-amber-300{
  --tw-text-opacity: 1 !important;
  color: rgb(252 211 77 / var(--tw-text-opacity, 1)) !important;
}
.text-amber-400{
  --tw-text-opacity: 1 !important;
  color: rgb(251 191 36 / var(--tw-text-opacity, 1)) !important;
}
.text-amber-500{
  --tw-text-opacity: 1 !important;
  color: rgb(245 158 11 / var(--tw-text-opacity, 1)) !important;
}
.text-black{
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1)) !important;
}
.text-blue-100{
  --tw-text-opacity: 1 !important;
  color: rgb(219 234 254 / var(--tw-text-opacity, 1)) !important;
}
.text-blue-300{
  --tw-text-opacity: 1 !important;
  color: rgb(147 197 253 / var(--tw-text-opacity, 1)) !important;
}
.text-blue-600{
  --tw-text-opacity: 1 !important;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1)) !important;
}
.text-blue-700{
  --tw-text-opacity: 1 !important;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1)) !important;
}
.text-emerald-400{
  --tw-text-opacity: 1 !important;
  color: rgb(52 211 153 / var(--tw-text-opacity, 1)) !important;
}
.text-gray-100{
  --tw-text-opacity: 1 !important;
  color: rgb(243 244 246 / var(--tw-text-opacity, 1)) !important;
}
.text-gray-400{
  --tw-text-opacity: 1 !important;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1)) !important;
}
.text-gray-600{
  --tw-text-opacity: 1 !important;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1)) !important;
}
.text-gray-700{
  --tw-text-opacity: 1 !important;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1)) !important;
}
.text-gray-900{
  --tw-text-opacity: 1 !important;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1)) !important;
}
.text-green-100{
  --tw-text-opacity: 1 !important;
  color: rgb(220 252 231 / var(--tw-text-opacity, 1)) !important;
}
.text-green-300{
  --tw-text-opacity: 1 !important;
  color: rgb(134 239 172 / var(--tw-text-opacity, 1)) !important;
}
.text-green-400{
  --tw-text-opacity: 1 !important;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1)) !important;
}
.text-green-500{
  --tw-text-opacity: 1 !important;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1)) !important;
}
.text-green-600{
  --tw-text-opacity: 1 !important;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1)) !important;
}
.text-green-700{
  --tw-text-opacity: 1 !important;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1)) !important;
}
.text-green-800{
  --tw-text-opacity: 1 !important;
  color: rgb(22 101 52 / var(--tw-text-opacity, 1)) !important;
}
.text-indigo-400{
  --tw-text-opacity: 1 !important;
  color: rgb(129 140 248 / var(--tw-text-opacity, 1)) !important;
}
.text-primary-600{
  --tw-text-opacity: 1 !important;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1)) !important;
}
.text-red-100{
  --tw-text-opacity: 1 !important;
  color: rgb(254 226 226 / var(--tw-text-opacity, 1)) !important;
}
.text-red-200{
  --tw-text-opacity: 1 !important;
  color: rgb(254 202 202 / var(--tw-text-opacity, 1)) !important;
}
.text-red-300{
  --tw-text-opacity: 1 !important;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1)) !important;
}
.text-red-400{
  --tw-text-opacity: 1 !important;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1)) !important;
}
.text-red-500{
  --tw-text-opacity: 1 !important;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1)) !important;
}
.text-red-600{
  --tw-text-opacity: 1 !important;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1)) !important;
}
.text-red-700{
  --tw-text-opacity: 1 !important;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1)) !important;
}
.text-red-800{
  --tw-text-opacity: 1 !important;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1)) !important;
}
.text-secondary-300{
  --tw-text-opacity: 1 !important;
  color: rgb(203 213 225 / var(--tw-text-opacity, 1)) !important;
}
.text-secondary-400{
  --tw-text-opacity: 1 !important;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1)) !important;
}
.text-secondary-500{
  --tw-text-opacity: 1 !important;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1)) !important;
}
.text-sky-400{
  --tw-text-opacity: 1 !important;
  color: rgb(56 189 248 / var(--tw-text-opacity, 1)) !important;
}
.text-slate-100{
  --tw-text-opacity: 1 !important;
  color: rgb(241 245 249 / var(--tw-text-opacity, 1)) !important;
}
.text-slate-400{
  --tw-text-opacity: 1 !important;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1)) !important;
}
.text-teal-300{
  --tw-text-opacity: 1 !important;
  color: rgb(94 234 212 / var(--tw-text-opacity, 1)) !important;
}
.text-white{
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}
.text-white\\/40{
  color: rgb(255 255 255 / 0.4) !important;
}
.text-white\\/50{
  color: rgb(255 255 255 / 0.5) !important;
}
.text-white\\/60{
  color: rgb(255 255 255 / 0.6) !important;
}
.text-white\\/70{
  color: rgb(255 255 255 / 0.7) !important;
}
.text-white\\/80{
  color: rgb(255 255 255 / 0.8) !important;
}
.text-white\\/85{
  color: rgb(255 255 255 / 0.85) !important;
}
.text-white\\/90{
  color: rgb(255 255 255 / 0.9) !important;
}
.text-yellow-500{
  --tw-text-opacity: 1 !important;
  color: rgb(234 179 8 / var(--tw-text-opacity, 1)) !important;
}
.text-yellow-700{
  --tw-text-opacity: 1 !important;
  color: rgb(161 98 7 / var(--tw-text-opacity, 1)) !important;
}
.text-yellow-800{
  --tw-text-opacity: 1 !important;
  color: rgb(133 77 14 / var(--tw-text-opacity, 1)) !important;
}
.text-yellow-900{
  --tw-text-opacity: 1 !important;
  color: rgb(113 63 18 / var(--tw-text-opacity, 1)) !important;
}
.underline{
  text-decoration-line: underline !important;
}
.placeholder-secondary-500::-moz-placeholder{
  --tw-placeholder-opacity: 1 !important;
  color: rgb(100 116 139 / var(--tw-placeholder-opacity, 1)) !important;
}
.placeholder-secondary-500::placeholder{
  --tw-placeholder-opacity: 1 !important;
  color: rgb(100 116 139 / var(--tw-placeholder-opacity, 1)) !important;
}
.opacity-25{
  opacity: 0.25 !important;
}
.opacity-75{
  opacity: 0.75 !important;
}
.opacity-85{
  opacity: 0.85 !important;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1) !important;
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-\\[0_0_0_1px_rgba\\(203\\2c 213\\2c 225\\2c 0\\.08\\)\\]{
  --tw-shadow: 0 0 0 1px rgba(203,213,225,0.08) !important;
  --tw-shadow-colored: 0 0 0 1px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-\\[0_0_0_1px_rgba\\(248\\2c 113\\2c 113\\2c 0\\.1\\)\\]{
  --tw-shadow: 0 0 0 1px rgba(248,113,113,0.1) !important;
  --tw-shadow-colored: 0 0 0 1px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-\\[0_0_0_1px_rgba\\(251\\2c 191\\2c 36\\2c 0\\.12\\)\\]{
  --tw-shadow: 0 0 0 1px rgba(251,191,36,0.12) !important;
  --tw-shadow-colored: 0 0 0 1px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-\\[0_0_0_1px_rgba\\(74\\2c 222\\2c 128\\2c 0\\.1\\)\\]{
  --tw-shadow: 0 0 0 1px rgba(74,222,128,0.1) !important;
  --tw-shadow-colored: 0 0 0 1px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-\\[0_0_0_2px_rgba\\(74\\2c 222\\2c 128\\2c 0\\.3\\)\\]{
  --tw-shadow: 0 0 0 2px rgba(74,222,128,0.3) !important;
  --tw-shadow-colored: 0 0 0 2px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-\\[0_0_10px_rgba\\(34\\2c 197\\2c 94\\2c 0\\.5\\)\\]{
  --tw-shadow: 0 0 10px rgba(34,197,94,0.5) !important;
  --tw-shadow-colored: 0 0 10px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-\\[0_0_8px_currentColor\\]{
  --tw-shadow: 0 0 8px currentColor !important;
  --tw-shadow-colored: 0 0 8px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-\\[0_0_8px_rgba\\(34\\2c 197\\2c 94\\2c 0\\.6\\)\\]{
  --tw-shadow: 0 0 8px rgba(34,197,94,0.6) !important;
  --tw-shadow-colored: 0 0 8px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-\\[0_18px_40px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.18\\)\\]{
  --tw-shadow: 0 18px 40px rgba(0,0,0,0.18) !important;
  --tw-shadow-colored: 0 18px 40px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-\\[0_24px_64px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.4\\)\\2c 0_8px_24px_rgba\\(52\\2c 52\\2c 74\\2c 0\\.3\\)\\2c 0_0_0_1px_rgba\\(255\\2c 255\\2c 255\\2c 0\\.06\\)\\]{
  --tw-shadow: 0 24px 64px rgba(0,0,0,0.4),0 8px 24px rgba(52,52,74,0.3),0 0 0 1px rgba(255,255,255,0.06) !important;
  --tw-shadow-colored: 0 24px 64px var(--tw-shadow-color), 0 8px 24px var(--tw-shadow-color), 0 0 0 1px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-\\[0_4px_20px_rgba\\(52\\2c 52\\2c 74\\2c 0\\.7\\)\\2c 0_2px_8px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.3\\)\\2c 0_0_0_2px_rgba\\(255\\2c 255\\2c 255\\2c 0\\.28\\)\\]{
  --tw-shadow: 0 4px 20px rgba(52,52,74,0.7),0 2px 8px rgba(0,0,0,0.3),0 0 0 2px rgba(255,255,255,0.28) !important;
  --tw-shadow-colored: 0 4px 20px var(--tw-shadow-color), 0 2px 8px var(--tw-shadow-color), 0 0 0 2px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-\\[0_8px_32px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.5\\)\\]{
  --tw-shadow: 0 8px 32px rgba(0,0,0,0.5) !important;
  --tw-shadow-colored: 0 8px 32px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-\\[12px_0_32px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.55\\)\\]{
  --tw-shadow: 12px 0 32px rgba(0,0,0,0.55) !important;
  --tw-shadow-colored: 12px 0 32px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-\\[inset_0_1px_0_rgba\\(255\\2c 255\\2c 255\\2c 0\\.035\\)\\]{
  --tw-shadow: inset 0 1px 0 rgba(255,255,255,0.035) !important;
  --tw-shadow-colored: inset 0 1px 0 var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-\\[inset_0_1px_0_rgba\\(255\\2c 255\\2c 255\\2c 0\\.04\\)\\]{
  --tw-shadow: inset 0 1px 0 rgba(255,255,255,0.04) !important;
  --tw-shadow-colored: inset 0 1px 0 var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1) !important;
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05) !important;
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.outline{
  outline-style: solid !important;
}
.ring-0{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}
.blur{
  --tw-blur: blur(8px) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.invert{
  --tw-invert: invert(100%) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.backdrop-blur-sm{
  --tw-backdrop-blur: blur(4px) !important;
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia) !important;
}
.backdrop-filter{
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia) !important;
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.transition-\\[margin\\]{
  transition-property: margin !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.transition-\\[width\\]{
  transition-property: width !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.transition-all{
  transition-property: all !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.transition-opacity{
  transition-property: opacity !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.transition-transform{
  transition-property: transform !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.duration-150{
  transition-duration: 150ms !important;
}
.duration-200{
  transition-duration: 200ms !important;
}
.duration-300{
  transition-duration: 300ms !important;
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
}
.ease-out{
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1) !important;
}

/* Base styles */
html {
  scroll-behavior: smooth;
}

body{
  font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif;
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #1b1e2f;
}

html,
body,
#outside,
#app {
  min-height: 100%;
  background: #1b1e2f;
}

h1,
h2,
h3,
h4,
h5,
h6{
  font-family: Poppins, Inter, system-ui, sans-serif;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}

h1{
  font-size: 2.25rem;
  line-height: 2.5rem;
  line-height: 1.25;
}

@media (min-width: 1024px){
  h1{
    font-size: 3rem;
    line-height: 1;
  }
}

@media (min-width: 1280px){
  h1{
    font-size: 3.75rem;
    line-height: 1;
  }
}
h2{
  font-size: 1.875rem;
  line-height: 2.25rem;
  line-height: 1.25;
}
@media (min-width: 1024px){
  h2{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }
}
h3{
  font-size: 1.5rem;
  line-height: 2rem;
  line-height: 1.375;
}
@media (min-width: 1024px){
  h3{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
}
h4{
  font-size: 1.25rem;
  line-height: 1.75rem;
  line-height: 1.375;
}
@media (min-width: 1024px){
  h4{
    font-size: 1.5rem;
    line-height: 2rem;
  }
}

p{
  font-size: 1rem;
  line-height: 1.5rem;
  line-height: 1.625;
}

@media (min-width: 1024px){
  p{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
}

code{
  border-radius: 0.25rem;
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-family: JetBrains Mono, Fira Code, Monaco, Consolas, monospace;
  font-size: 0.875rem;
  line-height: 1.25rem;
}

/* Components */
.btn{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  font-weight: 500;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
}
.btn:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-offset-width: 2px;
}
.btn-primary{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  font-weight: 500;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
}
.btn-primary:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-offset-width: 2px;
}
.btn-primary:hover{
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.btn-primary:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1));
}
.btn-secondary{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  font-weight: 500;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
}
.btn-secondary:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-offset-width: 2px;
}
.btn-secondary:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}
.btn-secondary:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(100 116 139 / var(--tw-ring-opacity, 1));
}
.btn-outline{
  border-width: 2px;
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  font-weight: 500;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
}
.btn-outline:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-offset-width: 2px;
}
.btn-outline:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.btn-outline:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1));
}
.btn-ghost{
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  font-weight: 500;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
}
.btn-ghost:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-offset-width: 2px;
}
.btn-ghost:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.btn-ghost:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(100 116 139 / var(--tw-ring-opacity, 1));
}
.btn-sm{
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.btn-lg{
  padding-left: 2rem;
  padding-right: 2rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  font-size: 1.125rem;
  line-height: 1.75rem;
}

.container{
  margin-left: auto;
  margin-right: auto;
  max-width: 80rem;
  padding-left: 1rem;
  padding-right: 1rem;
}

@media (min-width: 640px){
  .container{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}

@media (min-width: 1024px){
  .container{
    padding-left: 2rem;
    padding-right: 2rem;
  }
}
.container-sm{
  margin-left: auto;
  margin-right: auto;
  max-width: 56rem;
  padding-left: 1rem;
  padding-right: 1rem;
}
@media (min-width: 640px){
  .container-sm{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}
@media (min-width: 1024px){
  .container-sm{
    padding-left: 2rem;
    padding-right: 2rem;
  }
}
.container-xs{
  margin-left: auto;
  margin-right: auto;
  max-width: 42rem;
  padding-left: 1rem;
  padding-right: 1rem;
}
@media (min-width: 640px){
  .container-xs{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}
@media (min-width: 1024px){
  .container-xs{
    padding-left: 2rem;
    padding-right: 2rem;
  }
}

.section{
  padding-top: 4rem;
  padding-bottom: 4rem;
}

@media (min-width: 1024px){
  .section{
    padding-top: 6rem;
    padding-bottom: 6rem;
  }
}
.section-sm{
  padding-top: 3rem;
  padding-bottom: 3rem;
}
@media (min-width: 1024px){
  .section-sm{
    padding-top: 4rem;
    padding-bottom: 4rem;
  }
}

/* Navigation */
.nav-link{
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  border-radius: 0.75rem;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
}
.nav-link:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.nav-link-active{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(191 219 254 / var(--tw-ring-opacity, 1));
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  border-radius: 0.75rem;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
}
.nav-link-active:hover{
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}

/* Utilities */
.text-balance {
  overflow-wrap: break-word;
}
.scrollbar-hide {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.scrollbar-hide::-webkit-scrollbar {
  display: none;
}

.thin-scrollbar {
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
}
.thin-scrollbar::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
.thin-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}
.thin-scrollbar::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 9999px;
}
.thin-scrollbar::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.35);
}

* {
  scrollbar-color: rgba(148, 163, 184, 0.5) #24283a;
}

*::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

*::-webkit-scrollbar-track {
  background: #24283a;
}

*::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.55);
  border-radius: 9999px;
  border: 2px solid #24283a;
}

.shadow-strong {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

.placeholder\\:text-white\\/50::-moz-placeholder{
  color: rgb(255 255 255 / 0.5) !important;
}

.placeholder\\:text-white\\/50::placeholder{
  color: rgb(255 255 255 / 0.5) !important;
}

.last\\:border-b-0:last-child{
  border-bottom-width: 0px !important;
}

.hover\\:-translate-y-1:hover{
  --tw-translate-y: -0.25rem !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.hover\\:-translate-y-\\[1px\\]:hover{
  --tw-translate-y: -1px !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.hover\\:translate-x-\\[2px\\]:hover{
  --tw-translate-x: 2px !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.hover\\:scale-105:hover{
  --tw-scale-x: 1.05 !important;
  --tw-scale-y: 1.05 !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.hover\\:border-amber-400:hover{
  --tw-border-opacity: 1 !important;
  border-color: rgb(251 191 36 / var(--tw-border-opacity, 1)) !important;
}

.hover\\:border-blue-400:hover{
  --tw-border-opacity: 1 !important;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1)) !important;
}

.hover\\:border-green-400:hover{
  --tw-border-opacity: 1 !important;
  border-color: rgb(74 222 128 / var(--tw-border-opacity, 1)) !important;
}

.hover\\:border-primary-500:hover{
  --tw-border-opacity: 1 !important;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1)) !important;
}

.hover\\:border-red-400:hover{
  --tw-border-opacity: 1 !important;
  border-color: rgb(248 113 113 / var(--tw-border-opacity, 1)) !important;
}

.hover\\:border-white\\/20:hover{
  border-color: rgb(255 255 255 / 0.2) !important;
}

.hover\\:border-white\\/35:hover{
  border-color: rgb(255 255 255 / 0.35) !important;
}

.hover\\:bg-\\[\\#383d55\\]:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(56 61 85 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-\\[\\#3e3e58\\]:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(62 62 88 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-\\[\\#3f4059\\]:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(63 64 89 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-black\\/30:hover{
  background-color: rgb(0 0 0 / 0.3) !important;
}

.hover\\:bg-blue-700:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-gray-100:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-gray-50:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-primary-700:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-red-500\\/15:hover{
  background-color: rgb(239 68 68 / 0.15) !important;
}

.hover\\:bg-red-700:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-secondary-700:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-slate-300:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(203 213 225 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-white\\/10:hover{
  background-color: rgb(255 255 255 / 0.1) !important;
}

.hover\\:bg-white\\/15:hover{
  background-color: rgb(255 255 255 / 0.15) !important;
}

.hover\\:bg-white\\/25:hover{
  background-color: rgb(255 255 255 / 0.25) !important;
}

.hover\\:bg-white\\/5:hover{
  background-color: rgb(255 255 255 / 0.05) !important;
}

.hover\\:bg-white\\/\\[0\\.06\\]:hover{
  background-color: rgb(255 255 255 / 0.06) !important;
}

.hover\\:bg-white\\/\\[0\\.08\\]:hover{
  background-color: rgb(255 255 255 / 0.08) !important;
}

.hover\\:text-blue-600:hover{
  --tw-text-opacity: 1 !important;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:text-gray-600:hover{
  --tw-text-opacity: 1 !important;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:text-red-700:hover{
  --tw-text-opacity: 1 !important;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:text-secondary-400:hover{
  --tw-text-opacity: 1 !important;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:text-white:hover{
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:underline:hover{
  text-decoration-line: underline !important;
}

.hover\\:opacity-80:hover{
  opacity: 0.8 !important;
}

.hover\\:shadow-\\[0_6px_28px_rgba\\(52\\2c 52\\2c 74\\2c 0\\.9\\)\\2c 0_0_0_1px_rgba\\(255\\2c 255\\2c 255\\2c 0\\.22\\)\\]:hover{
  --tw-shadow: 0 6px 28px rgba(52,52,74,0.9),0 0 0 1px rgba(255,255,255,0.22) !important;
  --tw-shadow-colored: 0 6px 28px var(--tw-shadow-color), 0 0 0 1px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}

.hover\\:shadow-\\[0_8px_24px_rgba\\(239\\2c 68\\2c 68\\2c 0\\.25\\)\\]:hover{
  --tw-shadow: 0 8px 24px rgba(239,68,68,0.25) !important;
  --tw-shadow-colored: 0 8px 24px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}

.hover\\:shadow-\\[0_8px_24px_rgba\\(245\\2c 158\\2c 11\\2c 0\\.25\\)\\]:hover{
  --tw-shadow: 0 8px 24px rgba(245,158,11,0.25) !important;
  --tw-shadow-colored: 0 8px 24px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}

.hover\\:shadow-\\[0_8px_24px_rgba\\(255\\2c 255\\2c 255\\2c 0\\.08\\)\\]:hover{
  --tw-shadow: 0 8px 24px rgba(255,255,255,0.08) !important;
  --tw-shadow-colored: 0 8px 24px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}

.hover\\:shadow-\\[0_8px_24px_rgba\\(34\\2c 197\\2c 94\\2c 0\\.25\\)\\]:hover{
  --tw-shadow: 0 8px 24px rgba(34,197,94,0.25) !important;
  --tw-shadow-colored: 0 8px 24px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}

.hover\\:shadow-\\[0_8px_24px_rgba\\(59\\2c 130\\2c 246\\2c 0\\.25\\)\\]:hover{
  --tw-shadow: 0 8px 24px rgba(59,130,246,0.25) !important;
  --tw-shadow-colored: 0 8px 24px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}

.hover\\:shadow-lg:hover{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1) !important;
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}

.focus\\:border-primary-500:focus{
  --tw-border-opacity: 1 !important;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1)) !important;
}

.focus\\:border-white:focus{
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1)) !important;
}

.focus\\:border-white\\/50:focus{
  border-color: rgb(255 255 255 / 0.5) !important;
}

.focus\\:shadow-\\[0_0_0_3px_rgba\\(255\\2c 255\\2c 255\\2c 0\\.1\\)\\]:focus{
  --tw-shadow: 0 0 0 3px rgba(255,255,255,0.1) !important;
  --tw-shadow-colored: 0 0 0 3px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}

.focus\\:outline-none:focus{
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}

.focus\\:outline:focus{
  outline-style: solid !important;
}

.focus\\:outline-2:focus{
  outline-width: 2px !important;
}

.focus\\:outline-offset-\\[-2px\\]:focus{
  outline-offset: -2px !important;
}

.focus\\:outline-white:focus{
  outline-color: #fff !important;
}

.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}

.focus\\:ring-blue-500:focus{
  --tw-ring-opacity: 1 !important;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1)) !important;
}

.focus\\:ring-primary-500:focus{
  --tw-ring-opacity: 1 !important;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1)) !important;
}

.focus\\:ring-offset-0:focus{
  --tw-ring-offset-width: 0px !important;
}

.focus\\:ring-offset-2:focus{
  --tw-ring-offset-width: 2px !important;
}

.disabled\\:cursor-not-allowed:disabled{
  cursor: not-allowed !important;
}

.disabled\\:text-gray-400:disabled{
  --tw-text-opacity: 1 !important;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1)) !important;
}

.disabled\\:no-underline:disabled{
  text-decoration-line: none !important;
}

.disabled\\:opacity-50:disabled{
  opacity: 0.5 !important;
}

.disabled\\:opacity-60:disabled{
  opacity: 0.6 !important;
}

@media (max-width: 768px){
  .max-\\[768px\\]\\:gap-0{
    gap: 0px !important;
  }
  .max-\\[768px\\]\\:whitespace-nowrap{
    white-space: nowrap !important;
  }
  .max-\\[768px\\]\\:px-4{
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }
  .max-\\[768px\\]\\:py-3{
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }
}

@media (min-width: 640px){
  .sm\\:bottom-24{
    bottom: 6rem !important;
  }
  .sm\\:bottom-7{
    bottom: 1.75rem !important;
  }
  .sm\\:right-7{
    right: 1.75rem !important;
  }
  .sm\\:mb-5{
    margin-bottom: 1.25rem !important;
  }
  .sm\\:ml-auto{
    margin-left: auto !important;
  }
  .sm\\:mt-0{
    margin-top: 0px !important;
  }
  .sm\\:flex{
    display: flex !important;
  }
  .sm\\:h-14{
    height: 3.5rem !important;
  }
  .sm\\:h-6{
    height: 1.5rem !important;
  }
  .sm\\:h-7{
    height: 1.75rem !important;
  }
  .sm\\:min-h-\\[112px\\]{
    min-height: 112px !important;
  }
  .sm\\:w-14{
    width: 3.5rem !important;
  }
  .sm\\:w-6{
    width: 1.5rem !important;
  }
  .sm\\:w-7{
    width: 1.75rem !important;
  }
  .sm\\:w-auto{
    width: auto !important;
  }
  .sm\\:max-w-xs{
    max-width: 20rem !important;
  }
  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
  .sm\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  }
  .sm\\:flex-row{
    flex-direction: row !important;
  }
  .sm\\:flex-wrap{
    flex-wrap: wrap !important;
  }
  .sm\\:items-start{
    align-items: flex-start !important;
  }
  .sm\\:items-center{
    align-items: center !important;
  }
  .sm\\:justify-start{
    justify-content: flex-start !important;
  }
  .sm\\:justify-end{
    justify-content: flex-end !important;
  }
  .sm\\:justify-between{
    justify-content: space-between !important;
  }
  .sm\\:gap-3{
    gap: 0.75rem !important;
  }
  .sm\\:gap-5{
    gap: 1.25rem !important;
  }
  .sm\\:self-auto{
    align-self: auto !important;
  }
  .sm\\:border-l{
    border-left-width: 1px !important;
  }
  .sm\\:p-5{
    padding: 1.25rem !important;
  }
  .sm\\:p-6{
    padding: 1.5rem !important;
  }
  .sm\\:px-1{
    padding-left: 0.25rem !important;
    padding-right: 0.25rem !important;
  }
  .sm\\:px-5{
    padding-left: 1.25rem !important;
    padding-right: 1.25rem !important;
  }
  .sm\\:px-6{
    padding-left: 1.5rem !important;
    padding-right: 1.5rem !important;
  }
  .sm\\:py-5{
    padding-top: 1.25rem !important;
    padding-bottom: 1.25rem !important;
  }
  .sm\\:text-left{
    text-align: left !important;
  }
  .sm\\:text-2xl{
    font-size: 1.5rem !important;
    line-height: 2rem !important;
  }
  .sm\\:text-\\[0\\.688rem\\]{
    font-size: 0.688rem !important;
  }
  .sm\\:text-\\[2rem\\]{
    font-size: 2rem !important;
  }
  .sm\\:text-lg{
    font-size: 1.125rem !important;
    line-height: 1.75rem !important;
  }
}

@media (min-width: 768px){
  .md\\:col-span-2{
    grid-column: span 2 / span 2 !important;
  }
  .md\\:flex{
    display: flex !important;
  }
  .md\\:hidden{
    display: none !important;
  }
  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
  .md\\:p-3{
    padding: 0.75rem !important;
  }
  .md\\:px-4{
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }
}

@media (min-width: 1024px){
  .lg\\:col-span-2{
    grid-column: span 2 / span 2 !important;
  }
  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  }
  .lg\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
  }
  .lg\\:flex-row{
    flex-direction: row !important;
  }
  .lg\\:items-center{
    align-items: center !important;
  }
  .lg\\:justify-between{
    justify-content: space-between !important;
  }
  .lg\\:p-6{
    padding: 1.5rem !important;
  }
  .lg\\:p-7{
    padding: 1.75rem !important;
  }
  .lg\\:px-8{
    padding-left: 2rem !important;
    padding-right: 2rem !important;
  }
}

@media (min-width: 1280px){
  .xl\\:col-span-3{
    grid-column: span 3 / span 3 !important;
  }
  .xl\\:inline{
    display: inline !important;
  }
  .xl\\:hidden{
    display: none !important;
  }
  .xl\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  }
  .xl\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
  }
  .xl\\:text-4xl{
    font-size: 2.25rem !important;
    line-height: 2.5rem !important;
  }
}

@media (prefers-color-scheme: dark){
  .dark\\:bg-gray-700{
    --tw-bg-opacity: 1 !important;
    background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1)) !important;
  }
}

.\\[\\&_\\*\\]\\:\\!text-white *{
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AACA;EAAA,wBAA0B;EAA1B,wBAA0B;EAA1B,mBAA0B;EAA1B,mBAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,eAA0B;EAA1B,eAA0B;EAA1B,aAA0B;EAA1B,aAA0B;EAA1B,kBAA0B;EAA1B,sCAA0B;EAA1B,8BAA0B;EAA1B,6BAA0B;EAA1B,4BAA0B;EAA1B,eAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,kBAA0B;EAA1B,2BAA0B;EAA1B,4BAA0B;EAA1B,sCAA0B;EAA1B,kCAA0B;EAA1B,2BAA0B;EAA1B,sBAA0B;EAA1B,8BAA0B;EAA1B,YAA0B;EAA1B,kBAA0B;EAA1B,gBAA0B;EAA1B,iBAA0B;EAA1B,kBAA0B;EAA1B,cAA0B;EAA1B,gBAA0B;EAA1B,aAA0B;EAA1B,mBAA0B;EAA1B,qBAA0B;EAA1B,2BAA0B;EAA1B,yBAA0B;EAA1B,0BAA0B;EAA1B,2BAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,yBAA0B;EAA1B,sBAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,qBAA0B;EAA1B;AAA0B;AAA1B;EAAA,wBAA0B;EAA1B,wBAA0B;EAA1B,mBAA0B;EAA1B,mBAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,eAA0B;EAA1B,eAA0B;EAA1B,aAA0B;EAA1B,aAA0B;EAA1B,kBAA0B;EAA1B,sCAA0B;EAA1B,8BAA0B;EAA1B,6BAA0B;EAA1B,4BAA0B;EAA1B,eAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,kBAA0B;EAA1B,2BAA0B;EAA1B,4BAA0B;EAA1B,sCAA0B;EAA1B,kCAA0B;EAA1B,2BAA0B;EAA1B,sBAA0B;EAA1B,8BAA0B;EAA1B,YAA0B;EAA1B,kBAA0B;EAA1B,gBAA0B;EAA1B,iBAA0B;EAA1B,kBAA0B;EAA1B,cAA0B;EAA1B,gBAA0B;EAA1B,aAA0B;EAA1B,mBAA0B;EAA1B,qBAA0B;EAA1B,2BAA0B;EAA1B,yBAA0B;EAA1B,0BAA0B;EAA1B,2BAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,yBAA0B;EAA1B,sBAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,qBAA0B;EAA1B;AAA0B;AAA1B;;CAA0B,CAA1B;;;CAA0B;;AAA1B;;;EAAA,sBAA0B,EAA1B,MAA0B;EAA1B,eAA0B,EAA1B,MAA0B;EAA1B,mBAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;EAAA,gBAA0B;AAAA;;AAA1B;;;;;;;;CAA0B;;AAA1B;;EAAA,gBAA0B,EAA1B,MAA0B;EAA1B,8BAA0B,EAA1B,MAA0B;EAA1B,gBAA0B,EAA1B,MAA0B;EAA1B,cAA0B;KAA1B,WAA0B,EAA1B,MAA0B;EAA1B,8FAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,+BAA0B,EAA1B,MAA0B;EAA1B,wCAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;EAAA,SAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;EAAA,SAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,yCAA0B;UAA1B,iCAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;;;;;EAAA,kBAA0B;EAA1B,oBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,cAA0B;EAA1B,wBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,mBAA0B;AAAA;;AAA1B;;;;;CAA0B;;AAA1B;;;;EAAA,mEAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,+BAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,cAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,cAA0B;EAA1B,cAA0B;EAA1B,kBAA0B;EAA1B,wBAA0B;AAAA;;AAA1B;EAAA,eAA0B;AAAA;;AAA1B;EAAA,WAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;EAAA,cAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;EAA1B,yBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;;;;;EAAA,oBAA0B,EAA1B,MAA0B;EAA1B,8BAA0B,EAA1B,MAA0B;EAA1B,gCAA0B,EAA1B,MAA0B;EAA1B,eAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;EAA1B,uBAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;EAA1B,SAA0B,EAA1B,MAA0B;EAA1B,UAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,oBAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;;;;EAAA,0BAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,sBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,aAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,gBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,wBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,YAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;EAAA,6BAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,wBAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;EAAA,0BAA0B,EAA1B,MAA0B;EAA1B,aAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,kBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;;;;;;;;;;;;EAAA,SAA0B;AAAA;;AAA1B;EAAA,SAA0B;EAA1B,UAA0B;AAAA;;AAA1B;EAAA,UAA0B;AAAA;;AAA1B;;;EAAA,gBAA0B;EAA1B,SAA0B;EAA1B,UAA0B;AAAA;;AAA1B;;CAA0B;AAA1B;EAAA,UAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,gBAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;EAAA,UAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;EAAA,UAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,eAA0B;AAAA;;AAA1B;;CAA0B;AAA1B;EAAA,eAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;;;;;;;;EAAA,cAA0B,EAA1B,MAA0B;EAA1B,sBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,eAA0B;EAA1B,YAA0B;AAAA;;AAA1B,wEAA0B;AAA1B;EAAA,aAA0B;AAAA;AAC1B;EAAA;AAAgC;AAAhC;EAAA;AAAgC;AAAhC;EAAA;IAAA;EAAgC;EAAhC;IAAA;EAAgC;AAAA;AAAhC;EAAA;IAAA;EAAgC;EAAhC;IAAA;EAAgC;AAAA;AAAhC;EAAA;IAAA;EAAgC;EAAhC;IAAA;EAAgC;AAAA;AAAhC;EAAA;IAAA;EAAgC;EAAhC;IAAA;EAAgC;AAAA;AAAhC;EAAA;IAAA;EAAgC;EAAhC;IAAA;EAAgC;AAAA;AAChC;EAAA,6BAA+B;EAA/B,qBAA+B;EAA/B,sBAA+B;EAA/B,qBAA+B;EAA/B,uBAA+B;EAA/B,2BAA+B;EAA/B,iCAA+B;EAA/B,8BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,gCAA+B;EAA/B;AAA+B;AAA/B;EAAA,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;IAAA;EAA+B;EAA/B;IAAA;EAA+B;AAAA;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;IAAA;EAA+B;AAAA;AAA/B;EAAA;AAA+B;AAA/B;EAAA;IAAA;EAA+B;AAAA;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oCAA+B;KAA/B,iCAA+B;UAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,mCAA+B;KAA/B,gCAA+B;UAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,gCAA+B;OAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kCAA+B;EAA/B,iEAA+B;EAA/B;AAA+B;AAA/B;EAAA,kCAA+B;EAA/B,0EAA+B;EAA/B;AAA+B;AAA/B;EAAA,kCAA+B;EAA/B,yEAA+B;EAA/B;AAA+B;AAA/B;EAAA,kCAA+B;EAA/B,0EAA+B;EAA/B;AAA+B;AAA/B;EAAA,kCAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA,kCAA+B;EAA/B,0EAA+B;EAA/B;AAA+B;AAA/B;EAAA,kCAA+B;EAA/B,uEAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,yCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA,gCAA+B;EAA/B;AAA+B;AAA/B;EAAA,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,gCAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,gCAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,gCAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,gCAA+B;EAA/B;AAA+B;AAA/B;EAAA,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B;AAA+B;AAA/B;EAAA,gCAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,qFAA+B;EAA/B,yGAA+B;EAA/B;AAA+B;AAA/B;EAAA,wDAA+B;EAA/B,gEAA+B;EAA/B;AAA+B;AAA/B;EAAA,uDAA+B;EAA/B,gEAA+B;EAA/B;AAA+B;AAA/B;EAAA,uDAA+B;EAA/B,gEAA+B;EAA/B;AAA+B;AAA/B;EAAA,sDAA+B;EAA/B,gEAA+B;EAA/B;AAA+B;AAA/B;EAAA,sDAA+B;EAA/B,gEAA+B;EAA/B;AAA+B;AAA/B;EAAA,oDAA+B;EAA/B,+DAA+B;EAA/B;AAA+B;AAA/B;EAAA,4CAA+B;EAA/B,8DAA+B;EAA/B;AAA+B;AAA/B;EAAA,mDAA+B;EAA/B,8DAA+B;EAA/B;AAA+B;AAA/B;EAAA,oDAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,kHAA+B;EAA/B,uIAA+B;EAA/B;AAA+B;AAA/B;EAAA,gHAA+B;EAA/B,qIAA+B;EAA/B;AAA+B;AAA/B;EAAA,kDAA+B;EAA/B,iEAA+B;EAA/B;AAA+B;AAA/B;EAAA,oDAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,6DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0FAA+B;EAA/B,8GAA+B;EAA/B;AAA+B;AAA/B;EAAA,qDAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sHAA+B;EAA/B,oHAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,wCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,mKAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,sCAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,qCAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,mCAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,0GAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,uCAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yCAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;;AAE/B,gBAAgB;AAChB;EACE,uBAAuB;AACzB;;AAGE;EAAA,8FAA+C;EAA/C,oBAA+C;EAA/C,gDAA+C;EAA/C,mCAA+C;EAA/C,kCAA+C;EAC/C;AAD+C;;AAIjD;;;;EAIE,gBAAgB;EAChB,mBAAmB;AACrB;;AAQE;;;;;;EAAA,kDAAoD;EAApD,gBAAoD;EAApD,oBAAoD;EAApD;AAAoD;;AAIpD;EAAA,kBAAqD;EAArD,mBAAqD;EAArD;AAAqD;;AAArD;EAAA;IAAA,eAAqD;IAArD;EAAqD;AAAA;;AAArD;EAAA;IAAA,kBAAqD;IAArD;EAAqD;AAAA;AAGrD;EAAA,mBAAyC;EAAzC,oBAAyC;EAAzC;AAAyC;AAAzC;EAAA;IAAA,kBAAyC;IAAzC;EAAyC;AAAA;AAGzC;EAAA,iBAAwC;EAAxC,iBAAwC;EAAxC;AAAwC;AAAxC;EAAA;IAAA,mBAAwC;IAAxC;EAAwC;AAAA;AAGxC;EAAA,kBAAuC;EAAvC,oBAAuC;EAAvC;AAAuC;AAAvC;EAAA;IAAA,iBAAuC;IAAvC;EAAuC;AAAA;;AAIvC;EAAA,eAA2C;EAA3C,mBAA2C;EAA3C;AAA2C;;AAA3C;EAAA;IAAA,mBAA2C;IAA3C;EAA2C;AAAA;;AAI3C;EAAA,sBAA2D;EAA3D,kBAA2D;EAA3D,4DAA2D;EAA3D,oBAA2D;EAA3D,qBAA2D;EAA3D,oBAA2D;EAA3D,uBAA2D;EAA3D,mEAA2D;EAA3D,mBAA2D;EAA3D;AAA2D;;AAG7D,eAAe;AAEb;EAAA,oBAA2J;EAA3J,mBAA2J;EAA3J,uBAA2J;EAA3J,qBAA2J;EAA3J,oBAA2J;EAA3J,qBAA2J;EAA3J,oBAA2J;EAA3J,uBAA2J;EAA3J,gBAA2J;EAA3J,wJAA2J;EAA3J,wDAA2J;EAA3J;AAA2J;AAA3J;EAAA,8BAA2J;EAA3J,mBAA2J;EAA3J,2GAA2J;EAA3J,yGAA2J;EAA3J,4FAA2J;EAA3J;AAA2J;AAG3J;EAAA,+LAA2I;EAA3I,kBAA2I;EAA3I,0DAA2I;EAA3I,oBAA2I;EAA3I,mDAA2I;EAA3I,+EAA2I;EAA3I,mGAA2I;EAA3I,uGAA2I;EAA3I,oBAA2I;EAA3I,mBAA2I;EAA3I,uBAA2I;EAA3I,qBAA2I;EAA3I,oBAA2I;EAA3I,qBAA2I;EAA3I,oBAA2I;EAA3I,uBAA2I;EAA3I,gBAA2I;EAA3I,wJAA2I;EAA3I,wDAA2I;EAA3I;AAA2I;AAA3I;EAAA,8BAA2I;EAA3I,mBAA2I;EAA3I,2GAA2I;EAA3I,yGAA2I;EAA3I,4FAA2I;EAA3I;AAA2I;AAA3I;EAAA,2BAA2I;EAA3I,+LAA2I;EAA3I,kBAA2I;EAA3I,0DAA2I;EAA3I,gFAA2I;EAA3I,oGAA2I;EAA3I;AAA2I;AAA3I;EAAA,oBAA2I;EAA3I;AAA2I;AAG3I;EAAA,kBAA8F;EAA9F,4DAA8F;EAA9F,oBAA8F;EAA9F,gDAA8F;EAA9F,oBAA8F;EAA9F,mBAA8F;EAA9F,uBAA8F;EAA9F,qBAA8F;EAA9F,oBAA8F;EAA9F,qBAA8F;EAA9F,oBAA8F;EAA9F,uBAA8F;EAA9F,gBAA8F;EAA9F,wJAA8F;EAA9F,wDAA8F;EAA9F;AAA8F;AAA9F;EAAA,8BAA8F;EAA9F,mBAA8F;EAA9F,2GAA8F;EAA9F,yGAA8F;EAA9F,4FAA8F;EAA9F;AAA8F;AAA9F;EAAA,kBAA8F;EAA9F;AAA8F;AAA9F;EAAA,oBAA8F;EAA9F;AAA8F;AAG9F;EAAA,iBAAoH;EAApH,sBAAoH;EAApH,0DAAoH;EAApH,oBAAoH;EAApH,iDAAoH;EAApH,oBAAoH;EAApH,mBAAoH;EAApH,uBAAoH;EAApH,qBAAoH;EAApH,oBAAoH;EAApH,qBAAoH;EAApH,oBAAoH;EAApH,uBAAoH;EAApH,gBAAoH;EAApH,wJAAoH;EAApH,wDAAoH;EAApH;AAAoH;AAApH;EAAA,8BAAoH;EAApH,mBAAoH;EAApH,2GAAoH;EAApH,yGAAoH;EAApH,4FAAoH;EAApH;AAAoH;AAApH;EAAA,kBAAoH;EAApH,0DAAoH;EAApH,oBAAoH;EAApH;AAAoH;AAApH;EAAA,oBAAoH;EAApH;AAAoH;AAGpH;EAAA,oBAA6E;EAA7E,iDAA6E;EAA7E,oBAA6E;EAA7E,mBAA6E;EAA7E,uBAA6E;EAA7E,qBAA6E;EAA7E,oBAA6E;EAA7E,qBAA6E;EAA7E,oBAA6E;EAA7E,uBAA6E;EAA7E,gBAA6E;EAA7E,wJAA6E;EAA7E,wDAA6E;EAA7E;AAA6E;AAA7E;EAAA,8BAA6E;EAA7E,mBAA6E;EAA7E,2GAA6E;EAA7E,yGAA6E;EAA7E,4FAA6E;EAA7E;AAA6E;AAA7E;EAAA,kBAA6E;EAA7E;AAA6E;AAA7E;EAAA,oBAA6E;EAA7E;AAA6E;AAG7E;EAAA,kBAAwB;EAAxB,mBAAwB;EAAxB,mBAAwB;EAAxB,sBAAwB;EAAxB,mBAAwB;EAAxB;AAAwB;AAGxB;EAAA,kBAAwB;EAAxB,mBAAwB;EAAxB,iBAAwB;EAAxB,oBAAwB;EAAxB,mBAAwB;EAAxB;AAAwB;;AAIxB;EAAA,iBAA6C;EAA7C,kBAA6C;EAA7C,gBAA6C;EAA7C,kBAA6C;EAA7C;AAA6C;;AAA7C;EAAA;IAAA,oBAA6C;IAA7C;EAA6C;AAAA;;AAA7C;EAAA;IAAA,kBAA6C;IAA7C;EAA6C;AAAA;AAG7C;EAAA,iBAA6C;EAA7C,kBAA6C;EAA7C,gBAA6C;EAA7C,kBAA6C;EAA7C;AAA6C;AAA7C;EAAA;IAAA,oBAA6C;IAA7C;EAA6C;AAAA;AAA7C;EAAA;IAAA,kBAA6C;IAA7C;EAA6C;AAAA;AAG7C;EAAA,iBAA6C;EAA7C,kBAA6C;EAA7C,gBAA6C;EAA7C,kBAA6C;EAA7C;AAA6C;AAA7C;EAAA;IAAA,oBAA6C;IAA7C;EAA6C;AAAA;AAA7C;EAAA;IAAA,kBAA6C;IAA7C;EAA6C;AAAA;;AAI7C;EAAA,iBAAqB;EAArB;AAAqB;;AAArB;EAAA;IAAA,iBAAqB;IAArB;EAAqB;AAAA;AAGrB;EAAA,iBAAqB;EAArB;AAAqB;AAArB;EAAA;IAAA,iBAAqB;IAArB;EAAqB;AAAA;;AAGvB,eAAe;AAEb;EAAA,oBAAgK;EAAhK,mBAAgK;EAAhK,WAAgK;EAAhK,sBAAgK;EAAhK,kBAAgK;EAAhK,mBAAgK;EAAhK,qBAAgK;EAAhK,wBAAgK;EAAhK,gBAAgK;EAAhK,oBAAgK;EAAhK,gDAAgK;EAAhK,wJAAgK;EAAhK,wDAAgK;EAAhK;AAAgK;AAAhK;EAAA,kBAAgK;EAAhK,4DAAgK;EAAhK,oBAAgK;EAAhK;AAAgK;AAGhK;EAAA,kBAA4H;EAA5H,4DAA4H;EAA5H,iDAA4H;EAA5H,0CAA4H;EAA5H,uDAA4H;EAA5H,uGAA4H;EAA5H,2GAA4H;EAA5H,yGAA4H;EAA5H,4FAA4H;EAA5H,oBAA4H;EAA5H,6DAA4H;EAA5H,oBAA4H;EAA5H,mBAA4H;EAA5H,WAA4H;EAA5H,sBAA4H;EAA5H,kBAA4H;EAA5H,mBAA4H;EAA5H,qBAA4H;EAA5H,wBAA4H;EAA5H,gBAA4H;EAA5H,oBAA4H;EAA5H,gDAA4H;EAA5H,wJAA4H;EAA5H,wDAA4H;EAA5H;AAA4H;AAA5H;EAAA,4DAA4H;EAA5H,kBAA4H;EAA5H,4DAA4H;EAA5H,oBAA4H;EAA5H;AAA4H;;AAG9H,cAAc;AACd;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,uBAAuB;AACzB;AACA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;AACA;EACE,qCAAqC;AACvC;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAzJA;EAAA;AA0JA;;AA1JA;EAAA;AA0JA;;AA1JA;EAAA;AA0JA;;AA1JA;EAAA,qCA0JA;EA1JA;AA0JA;;AA1JA;EAAA,iCA0JA;EA1JA;AA0JA;;AA1JA;EAAA,gCA0JA;EA1JA;AA0JA;;AA1JA;EAAA,6BA0JA;EA1JA,6BA0JA;EA1JA;AA0JA;;AA1JA;EAAA,iCA0JA;EA1JA;AA0JA;;AA1JA;EAAA,iCA0JA;EA1JA;AA0JA;;AA1JA;EAAA,iCA0JA;EA1JA;AA0JA;;AA1JA;EAAA,iCA0JA;EA1JA;AA0JA;;AA1JA;EAAA,iCA0JA;EA1JA;AA0JA;;AA1JA;EAAA;AA0JA;;AA1JA;EAAA;AA0JA;;AA1JA;EAAA,6BA0JA;EA1JA;AA0JA;;AA1JA;EAAA,6BA0JA;EA1JA;AA0JA;;AA1JA;EAAA,6BA0JA;EA1JA;AA0JA;;AA1JA;EAAA;AA0JA;;AA1JA;EAAA,6BA0JA;EA1JA;AA0JA;;AA1JA;EAAA,6BA0JA;EA1JA;AA0JA;;AA1JA;EAAA,6BA0JA;EA1JA;AA0JA;;AA1JA;EAAA,6BA0JA;EA1JA;AA0JA;;AA1JA;EAAA;AA0JA;;AA1JA;EAAA,6BA0JA;EA1JA;AA0JA;;AA1JA;EAAA,6BA0JA;EA1JA;AA0JA;;AA1JA;EAAA,6BA0JA;EA1JA;AA0JA;;AA1JA;EAAA;AA0JA;;AA1JA;EAAA;AA0JA;;AA1JA;EAAA;AA0JA;;AA1JA;EAAA;AA0JA;;AA1JA;EAAA;AA0JA;;AA1JA;EAAA;AA0JA;;AA1JA;EAAA,+BA0JA;EA1JA;AA0JA;;AA1JA;EAAA,+BA0JA;EA1JA;AA0JA;;AA1JA;EAAA,+BA0JA;EA1JA;AA0JA;;AA1JA;EAAA,+BA0JA;EA1JA;AA0JA;;AA1JA;EAAA,+BA0JA;EA1JA;AA0JA;;AA1JA;EAAA;AA0JA;;AA1JA;EAAA;AA0JA;;AA1JA;EAAA,sFA0JA;EA1JA,mGA0JA;EA1JA;AA0JA;;AA1JA;EAAA,uDA0JA;EA1JA,iEA0JA;EA1JA;AA0JA;;AA1JA;EAAA,wDA0JA;EA1JA,iEA0JA;EA1JA;AA0JA;;AA1JA;EAAA,yDA0JA;EA1JA,iEA0JA;EA1JA;AA0JA;;AA1JA;EAAA,uDA0JA;EA1JA,iEA0JA;EA1JA;AA0JA;;AA1JA;EAAA,wDA0JA;EA1JA,iEA0JA;EA1JA;AA0JA;;AA1JA;EAAA,0FA0JA;EA1JA,8GA0JA;EA1JA;AA0JA;;AA1JA;EAAA,iCA0JA;EA1JA;AA0JA;;AA1JA;EAAA,iCA0JA;EA1JA;AA0JA;;AA1JA;EAAA;AA0JA;;AA1JA;EAAA,uDA0JA;EA1JA,gEA0JA;EA1JA;AA0JA;;AA1JA;EAAA,yCA0JA;EA1JA;AA0JA;;AA1JA;EAAA;AA0JA;;AA1JA;EAAA;AA0JA;;AA1JA;EAAA;AA0JA;;AA1JA;EAAA;AA0JA;;AA1JA;EAAA,sHA0JA;EA1JA,oHA0JA;EA1JA;AA0JA;;AA1JA;EAAA,+BA0JA;EA1JA;AA0JA;;AA1JA;EAAA,+BA0JA;EA1JA;AA0JA;;AA1JA;EAAA;AA0JA;;AA1JA;EAAA;AA0JA;;AA1JA;EAAA;AA0JA;;AA1JA;EAAA,+BA0JA;EA1JA;AA0JA;;AA1JA;EAAA;AA0JA;;AA1JA;EAAA;AA0JA;;AA1JA;EAAA;AA0JA;;AA1JA;EAAA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA,6BA0JA;IA1JA;EA0JA;EA1JA;IAAA,+BA0JA;IA1JA;EA0JA;AAAA;;AA1JA;EAAA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA,gCA0JA;IA1JA;EA0JA;EA1JA;IAAA,gCA0JA;IA1JA;EA0JA;EA1JA;IAAA,+BA0JA;IA1JA;EA0JA;EA1JA;IAAA,+BA0JA;IA1JA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA,4BA0JA;IA1JA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA,8BA0JA;IA1JA;EA0JA;AAAA;;AA1JA;EAAA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA,6BA0JA;IA1JA;EA0JA;AAAA;;AA1JA;EAAA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA,6BA0JA;IA1JA;EA0JA;AAAA;;AA1JA;EAAA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA;EA0JA;EA1JA;IAAA,6BA0JA;IA1JA;EA0JA;AAAA;;AA1JA;EAAA;IAAA,6BA0JA;IA1JA;EA0JA;AAAA;;AA1JA;EAAA,+BA0JA;EA1JA;AA0JA","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&family=Poppins:wght@300;400;500;600;700;800;900&family=JetBrains+Mono:wght@300;400;500;600;700&display=swap\");\n@import \"tailwindcss/base\";\n@import \"tailwindcss/components\";\n@import \"tailwindcss/utilities\";\n\n/* Base styles */\nhtml {\n  scroll-behavior: smooth;\n}\n\nbody {\n  @apply font-sans text-secondary-800 antialiased;\n  background: #1b1e2f;\n}\n\nhtml,\nbody,\n#outside,\n#app {\n  min-height: 100%;\n  background: #1b1e2f;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  @apply font-display font-semibold text-secondary-900;\n}\n\nh1 {\n  @apply text-4xl lg:text-5xl xl:text-6xl leading-tight;\n}\nh2 {\n  @apply text-3xl lg:text-4xl leading-tight;\n}\nh3 {\n  @apply text-2xl lg:text-3xl leading-snug;\n}\nh4 {\n  @apply text-xl lg:text-2xl leading-snug;\n}\n\np {\n  @apply text-base lg:text-lg leading-relaxed;\n}\n\ncode {\n  @apply font-mono text-sm bg-secondary-100 px-2 py-1 rounded;\n}\n\n/* Components */\n.btn {\n  @apply inline-flex items-center justify-center px-6 py-3 rounded-lg font-medium transition duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2;\n}\n.btn-primary {\n  @apply btn bg-primary-600 text-white hover:bg-primary-700 focus:ring-primary-500 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5;\n}\n.btn-secondary {\n  @apply btn bg-secondary-100 text-secondary-700 hover:bg-secondary-200 focus:ring-secondary-500;\n}\n.btn-outline {\n  @apply btn border-2 border-primary-600 text-primary-600 hover:bg-primary-600 hover:text-white focus:ring-primary-500;\n}\n.btn-ghost {\n  @apply btn text-secondary-600 hover:bg-secondary-100 focus:ring-secondary-500;\n}\n.btn-sm {\n  @apply px-4 py-2 text-sm;\n}\n.btn-lg {\n  @apply px-8 py-4 text-lg;\n}\n\n.container {\n  @apply max-w-7xl mx-auto px-4 sm:px-6 lg:px-8;\n}\n.container-sm {\n  @apply max-w-4xl mx-auto px-4 sm:px-6 lg:px-8;\n}\n.container-xs {\n  @apply max-w-2xl mx-auto px-4 sm:px-6 lg:px-8;\n}\n\n.section {\n  @apply py-16 lg:py-24;\n}\n.section-sm {\n  @apply py-12 lg:py-16;\n}\n\n/* Navigation */\n.nav-link {\n  @apply inline-flex items-center gap-2 px-4 py-2.5 text-secondary-700 font-semibold transition duration-200 rounded-xl hover:text-primary-700 hover:bg-primary-50;\n}\n.nav-link-active {\n  @apply nav-link text-primary-700 bg-primary-50 shadow-sm ring-1 ring-primary-200 hover:text-primary-700 hover:bg-primary-100;\n}\n\n/* Utilities */\n.text-balance {\n  overflow-wrap: break-word;\n}\n.scrollbar-hide {\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n.scrollbar-hide::-webkit-scrollbar {\n  display: none;\n}\n\n.thin-scrollbar {\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n}\n.thin-scrollbar::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n.thin-scrollbar::-webkit-scrollbar-track {\n  background: transparent;\n}\n.thin-scrollbar::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 9999px;\n}\n.thin-scrollbar::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.35);\n}\n\n* {\n  scrollbar-color: rgba(148, 163, 184, 0.5) #24283a;\n}\n\n*::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n\n*::-webkit-scrollbar-track {\n  background: #24283a;\n}\n\n*::-webkit-scrollbar-thumb {\n  background: rgba(148, 163, 184, 0.55);\n  border-radius: 9999px;\n  border: 2px solid #24283a;\n}\n\n.shadow-strong {\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
